module.exports = __webpack_public_path__ + "static/media/phdc.50ce797d.svg";